<template>
  <section class="page-section">
    <div class="tab-account">
      <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange">
        <el-tab-pane label="服务" name="0"></el-tab-pane>
        <el-tab-pane label="商品" name="1"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 筛选 -->
    <div class="filter-region no-margin-top">
      <div class="filter-form">
        <el-form
          size="small"
          :inline="true"
          :model="filterForm"
          ref="filterForm"
        >
          <el-form-item label="日期：" prop="dateType" class="auto-width">
            <el-select
              v-model="filterForm.dateType"
              placeholder="请选择"
              @change="handleDateTypeChange"
            >
              <el-option label="全部" :value="null"></el-option>
              <el-option label="自然年" value="year"></el-option>
              <el-option label="自然月" value="month"></el-option>
            </el-select>
            <el-date-picker
              v-if="filterForm.dateType === 'year'"
              v-model="filterForm.year"
              type="year"
              format="yyyy"
              value-format="yyyy"
              placeholder="请选择"
              style="margin-left: 10px"
            >
            </el-date-picker>
            <el-date-picker
              v-if="filterForm.dateType === 'month'"
              v-model="filterForm.month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="请选择"
              style="margin-left: 10px"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="filter-btn">
        <el-button
          class="btn-export"
          type="primary"
          plain
          @click="importDialogVisible = true"
          >导入（{{ tabName == "0" ? "服务" : "商品" }}）</el-button
        >
        <el-button-group class="btn-group">
          <el-button
            plain
            class="btn-reset"
            icon="el-icon-refresh"
            @click="filterFormReset('filterForm')"
          ></el-button>
          <el-button
            type="primary"
            class="btn-search"
            @click="filterFormSubmit('filterForm')"
            :loading="tableLoading"
            >查询</el-button
          >
        </el-button-group>
      </div>
    </div>

    <div class="form-module">
      <div class="module-body">
        <div class="table-region" v-loading="tableLoading">
          <div class="statistics">
            <span class="item"
              >可提现总金额：￥{{ statistics.validBalance || 0 }}</span
            >
            <span class="item"
              >冻结中总金额：￥{{ statistics.frozenBalance || 0 }}</span
            >
            <span class="item"
              >已提现总金额：￥{{
                tabName == "0"
                  ? statistics.serviceWithdrawnAmount
                  : statistics.orderWithdrawnAmount
              }}</span
            >
          </div>
          <!-- 列表 -->
          <el-table :data="tableData" style="margin-top: 20px">
            <el-table-column
              v-for="(item, index) in tableColumn"
              :key="index"
              :prop="item.prop"
              :label="item.label"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row[item.prop]
                  }}{{
                    item.label === "服务佣金比率" &&
                    scope.row[item.prop] != null
                      ? "%"
                      : ""
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right" width="80">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="deleteItem(scope)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate"></div>
          <div class="pagination-wrap">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]"
              :pager-count="5"
              :current-page="page.current"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <import-dialog
      :visible.sync="importDialogVisible"
      :type="tabName"
      @success="handleImportSuccess"
    ></import-dialog>
  </section>
</template>

<script>
import {
  COMMON,
  distributorWithdrawStatistics,
  agentWithdrawalsList,
  agentWithdrawalsDelete,
} from "@/common/api";
import ImportDialog from "./components/import-dialog.vue";

export default {
  components: {
    ImportDialog,
  },
  data() {
    return {
      COMMON,
      id:
        localStorage.getItem("companyId") &&
        localStorage.getItem("companyId") !== "null"
          ? localStorage.getItem("companyId")
          : null,
      filterForm: {
        // 筛选表单值
        dateType: null,
        year: "",
        month: "",
      },
      tableData: [],
      tableLoading: false,
      importDialogVisible: false,
      page: {
        // 分页参数
        current: 1,
        size: 20,
        total: 0,
      },
      statistics: {},
      tabName: "0",
    };
  },
  computed: {
    tableColumn() {
      if (this.tabName == "1") {
        return [
          {
            prop: "companyId",
            label: "代理商ID",
          },
          {
            prop: "userName",
            label: "个人代理名称",
          },
          {
            prop: "commission",
            label: "本次提现金额",
          },
          {
            prop: "remainingBalance",
            label: "剩余可提现金额",
          },
          {
            prop: "totalWithdrawnAmount",
            label: "历史提现金额",
          },
        ];
      } else {
        return [
          {
            prop: "companyId",
            label: "代理商ID",
          },
          {
            prop: "userName",
            label: "个人代理名称",
          },
          {
            prop: "serviceLevel",
            label: "服务代理等级",
          },
          {
            prop: "servicePercentage",
            label: "服务佣金比率",
          },
          {
            prop: "salesAmountKrw",
            label: "销售额(韩币)₩",
          },
          {
            prop: "deductedTaxAmount",
            label: "扣除1.1附加税金额",
          },
          {
            prop: "exchangeRate",
            label: "汇率",
          },
          {
            prop: "amountRmb",
            label: "人民币",
          },
          {
            prop: "commission",
            label: "佣金",
          },
          {
            prop: "remainingBalance",
            label: "剩余可提现金额",
          },
          {
            prop: "serviceFee",
            label: "灵活用工，另外收取0.065服务费",
          },
          {
            prop: "totalLossAmount",
            label: "合计报销金额",
          },
        ];
      }
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleTabsChange() {
      this.page.current = 1;
      this.getList();
    },
    handleDateTypeChange() {
      this.filterForm.year = "";
      this.filterForm.month = "";
    },
    handleGetTime(type) {
      let startTime, endTime;
      if (this.filterForm.dateType === "year" && this.filterForm.year) {
        // 计算年的起始和结束时间
        startTime = new Date(
          `${this.filterForm.year}-01-01 00:00:00`,
        ).getTime();
        endTime = new Date(`${this.filterForm.year}-12-31 23:59:59`).getTime();
      } else if (
        this.filterForm.dateType === "month" &&
        this.filterForm.month
      ) {
        // 计算月的起始和结束时间
        const [year, month] = this.filterForm.month.split("-");
        const lastDay = new Date(year, month, 0).getDate();

        startTime = new Date(`${year}-${month}-01 00:00:00`).getTime();
        endTime = new Date(`${year}-${month}-${lastDay} 23:59:59`).getTime();
      } else {
        this.$message.warning("请选择日期范围");
        return;
      }
      if (type === "start") {
        return startTime;
      } else if (type === "end") {
        return endTime;
      }
    },
    // 提交筛选表单
    filterFormSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.page.current = 1;
          this.getList();
        } else {
          return false;
        }
      });
    },
    // 重置筛选表单
    filterFormReset(formName) {
      this.$refs[formName].resetFields();
      this.page.current = 1;
      this.getList();
    },
    // 获取 tab 列表数据
    getList() {
      this.getWithdrawalsList();
      this.getStatics();
    },
    // 提现明细列表
    getWithdrawalsList() {
      this.tableLoading = true;
      const { dateType } = this.filterForm;
      console.log(this.tabName);
      let params = {
        type: this.tabName,
        startTime: dateType ? this.handleGetTime("start") : "",
        endTime: dateType ? this.handleGetTime("end") : "",
        pageNo: this.page.current,
        pageSize: this.page.size,
      };
      if (this.id) {
        params.companyId = this.id;
      }
      agentWithdrawalsList(params)
        .then((res) => {
          let { code, data, msg } = res;
          if (code == 0) {
            this.tableData = data.records || [];
            this.tableLoading = false;
            this.page.total = data.total;
            this.$forceUpdate();
            this.$nextTick(() => {
              const scrollContainer = document.querySelector(".app-container");
              if (scrollContainer) {
                scrollContainer.scrollTop = 0;
              }
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    // 分页每页条数变化
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;
      this.getList();
    },
    // 选择分页第几页
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    //  统计
    getStatics() {
      const { dateType, year, month } = this.filterForm;
      let params = {
        type: parseInt(1), // 0=公司代理，1=个人代理
        withdrawStatus: 2,
      };
      // 处理 endDate 参数
      if (dateType === "year" && year) {
        params.endDate = `${year}-12-31`;
      } else if (dateType === "month" && month) {
        // 计算该月最后一天
        const [y, m] = month.split("-");
        const lastDay = new Date(y, m, 0).getDate();
        params.endDate = `${month}-${lastDay.toString().padStart(2, "0")}`;
      }
      distributorWithdrawStatistics(params)
        .then((res) => {
          let { code, data, msg, message } = res;
          // 兼容不同的响应码格式
          if (code == 0 || code == "200" || code == "20000") {
            // 映射返回字段
            Object.assign(this.statistics, {
              validBalance: data.totalValidBalance || 0,
              frozenBalance: data.totalFrozenBalance || 0,
              withdrawBalance: data.totalWithdrawnAmount || 0,
              ...data,
            });
            this.$forceUpdate();
          } else {
            this.$message.error(msg || message || "获取统计信息失败");
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    deleteItem(e) {
      console.log(e.row);
      agentWithdrawalsDelete({ id: e.row.id })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg || "删除成功");
            this.tableData = this.tableData.filter(
              (item) => item.id !== e.row.id,
            );
            this.page.total--;
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    handleImportSuccess() {
      this.page.current = 1;
      this.getList();
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/_mixin-font";
@import "../../../common/styles/base/mixin-common";
.tab-account {
  ::v-deep .el-tabs {
    .el-tabs__item {
      padding: 0 80px !important;
      font-size: 14px;
    }
    .is-active {
      color: #3388ff;
      background: #ebf3ff;
      border: 1px solid #adcfff;
    }
  }
}

.filter-region {
  display: flex;
  align-items: center;
  border: none;

  &.no-margin-top {
    margin-top: 20px !important;
  }

  .filter-form {
    flex: 1;
  }

  .filter-btn {
    height: 100%;
    display: flex;
    .btn-export {
      height: 40px;
      padding: 0 18px;
      border-radius: 5px;
      line-height: 38px;
      margin-right: 12px;
    }

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        & + .el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.table-region {
  .statistics {
    margin-top: -10px;
    padding: 20px;
    background: #effaff;
    border-radius: 4px;
    font-size: 0;
    flex-shrink: 0;

    .item {
      display: inline-block;
      width: 240px;
      font-size: 12px;
      color: #222222;
      letter-spacing: 0;
      font-weight: 600;
    }
  }

  ::v-deep .el-table {
    &::before {
      height: 0;
    }
  }
}
</style>
